const e=async(e,t)=>{let{data:n}=await e.post(`/users/invite`,t);return n};export{e as inviteUsers};
//# sourceMappingURL=invite-users.mjs.map